function removePrefix(prefix, key) {
	const prefixLength = prefix.length
	let newKey = key

	if (key.substr(0, prefixLength) === prefix) {
		newKey = key.substr(prefixLength)
	}

	return newKey
}

export default removePrefix
